module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/ferrara.4e8639d6da498558184e9707d298d133.jpg";